import { useAppSelector } from 'store/hooks';

export const useFullscreenLoader = () => {
  const {
    actions: { setFullscreenLoading },
    fullscreenLoading: { isFullscreenLoading, fullscreenLoadingText },
  } = useAppSelector('UI', ['fullscreenLoading', 'actions']);

  return { isFullscreenLoading, fullscreenLoadingText, setFullscreenLoading };
};
